export const WorkerHttpPaths = {
  Worker: (id: string) => `/nurses/${id}`,
  WorkerDetails: (id: string) => `/nurses/${id}/details`,
  WorkerHistoryShifts: (id: string) => `/nurses/${id}/shifts`,
  Complaints: '/complaints',
  checklist: (staffId: string, shiftId: string) =>
    `/nurses/${staffId}/checklist/${shiftId}`,
};
